import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
function AppContent() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',background:'#1a1a2e',color:'#fff',fontSize:'24px'}}>⏳</div>
  );
  return user ? <Dashboard /> : <Login />;
}
export default function App() {
  return <AuthProvider><AppContent /></AuthProvider>;
}
